export interface OperatorTrackingConfig {
    googleTag?: string
    facebookPixel?: string
}

export const operatorsTracking: Record<string, OperatorTrackingConfig> = {
    "acme": {
        googleTag: "G-PR32QC9R3M",
    },
    "mshikebet-ke": {
        googleTag: "AW-17828510979",
    },
}